"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = require("gsap");
const WaveTypo_1 = __importDefault(require("./WaveTypo"));
const vs = `
  varying vec2 v_uv;
  void main() {
    v_uv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;
const fs = `
  precision mediump float;
  varying vec2 v_uv;
  uniform vec3 u_metaballs[50];

  void main() {
    vec2 uv = v_uv;
    vec2 st = 2.0 * uv - 1.0;
    float v = 0.0;
    for ( int i = 0; i < 50; i++ ) {
      vec3 mb = u_metaballs[i];
      float dx = st.x + mb.x;
      float dy = st.y + mb.y;
      float r = mb.z;
      v += r * r / (dx * dx + dy * dy);
    }
    //vec4 color = vec4(17.0/255.0, 17.0/255.0, 17.0/255.0, 1.0);
    vec4 color = vec4(0., 0., 0., 1.0);
    if (v > 2.7) {
      color.a = 0.0;
      color.rgb = vec3(1.0);
    } else {
      //color = vec4(0.0, 0.0, 0.0, 1.0);
    }
    //color = vec4(0.0, 0.0, 0.0, 1.0);
    gl_FragColor = color;
  }
`;
class SinkMetaball extends THREE.Object3D {
    constructor(width = 1, height = 1, texture) {
        super();
        this.NUM_METABALLS = 50;
        this.metaballs = [];
        this.uniforms = {
            u_progress: { value: 0.0 },
            u_time: { value: 0.0 },
            u_metaballs: { type: 'v3', value: this.metaballs },
        };
        this.width = width;
        this.height = height;
        this.shape = null;
        this.wireframe = null;
        this.typo = null;
        this.draw(texture);
    }
    draw(texture) {
        this._createMetaballs();
        this._createShape();
        this._createTypo(texture);
        this._animate();
    }
    update() {
        var _a;
        this.uniforms.u_time.value += 0.01;
        (_a = this.typo) === null || _a === void 0 ? void 0 : _a.update();
        this.metaballs.forEach(ball => {
            if (!ball.ready)
                return;
            ball.update();
        });
    }
    hide(cb) {
        this.metaballs.forEach(mb => {
            gsap_1.gsap.delayedCall(Math.random() * 1.5, () => {
                mb.setTarget(0, -2.5);
            });
        });
        gsap_1.gsap.delayedCall(3.5, () => {
            cb();
        });
    }
    _animate() {
        this.metaballs.forEach(mb => {
            gsap_1.gsap.delayedCall(Math.random() * 4, () => {
                mb._ready = true;
            });
        });
    }
    _createShape() {
        this.uniforms = {
            u_progress: { value: 0.0 },
            u_time: { value: 0.0 },
            u_metaballs: { type: 'v3', value: this.metaballs },
        };
        const geo = new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1);
        const mat = new THREE.ShaderMaterial({
            vertexShader: vs,
            fragmentShader: fs,
            uniforms: this.uniforms,
            transparent: true,
            side: THREE.DoubleSide,
        });
        this.shape = new THREE.Mesh(geo, mat);
        this.add(this.shape);
    }
    _createWireframe() {
        this.wireframe = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        this.add(this.wireframe);
    }
    _createMetaballs() {
        for (let i = 0; i < this.NUM_METABALLS; i++) {
            const v = new Metaball(Math.random() * 0.8 - 0.4, Math.random() * 0.8 + 1.2, Math.random() * 0.2 + 0.02);
            this.metaballs.push(v);
        }
    }
    _createTypo(texture) {
        this.typo = new WaveTypo_1.default(this.width, this.height, texture);
        this.typo.draw();
        this.typo.position.z = -0.2;
        this.add(this.typo);
    }
}
exports.default = SinkMetaball;
class Metaball extends THREE.Vector3 {
    constructor(x, y, z) {
        super(x, y, z);
        this.target = new THREE.Vector2(Math.random() * 0.4 - 0.2, 0);
        this.velocity = new THREE.Vector2();
        this.acceleration = new THREE.Vector2();
        this._ready = false;
        this.velocityMax = 0.03;
        this.acceLength = 0.002;
    }
    get ready() {
        return this._ready;
    }
    set ready(value) {
        this._ready = value;
    }
    setTarget(x, y) {
        this.target.set(x, y);
    }
    update() {
        const _sub = new THREE.Vector2(this.x, this.y);
        const acce = this.target.clone().sub(_sub);
        acce.normalize().multiplyScalar(this.acceLength);
        this.acceleration = acce;
        this.velocity.add(this.acceleration);
        this.velocity.clampLength(0, this.velocityMax);
        this.x += this.velocity.x;
        this.y += this.velocity.y;
    }
}
